export const REGISTRY_TABS = [
    {
        key: 'contracts',
        label: 'Contracts'
    },
    {
        key: 'companies',
        label: 'Companies'
    },
    {
        key: 'contacts',
        label: 'Contacts'
    },
    {
        key: 'govorgs',
        label: 'Government Orgs'
    },
    {
        key: 'capabilities',
        label: 'Capabilities'
    },
    {
        key: 'vehicles',
        label: 'Contract Vehicles'
    },
    {
        key: 'lcats',
        label: 'Labor Categories'
    },
    {
        key: 'rate-book',
        label: 'Rate Book'
    },
    {
        key: 'roles',
        label: 'Program Roles'
    },
    {
        key: 'pricing-sheets',
        label: 'Pricing Sheets'
    }
];
export const isRegistryTabKey = (s)=>REGISTRY_TABS.some((tab)=>tab.key === s);
export const registryTabLabel = (key)=>REGISTRY_TABS.find((tab)=>tab.key === key)?.label ?? key;
